import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {channelsFeatureKey, ChannelsState} from "./channel.reducer";

export const getChannelsState = createFeatureSelector<ChannelsState>(channelsFeatureKey);

export const getChannels = createSelector(getChannelsState, (state) => state.data);
export const getChannelsLoading = createSelector(getChannelsState, SelectorUtil.isLoading);
